const WHITESPACE = /\s/;
const ALL_WHITESPACE = /\s+/g;

/** Entity names become backend identifiers, which cannot contain spaces. */
export const hasWhitespace = (value) => WHITESPACE.test(value || "");

export const stripWhitespace = (value) => (value || "").replace(ALL_WHITESPACE, "");
